import { BuiltinInterface } from '../BuiltinInterface';
import { BuiltinValueObject } from '../BuiltinValueObject';
import { SymbolFor } from './for';
import { SymbolIterator } from './iterator';
import { SymbolToPrimitive } from './toPrimitive';
class SymbolInterface extends BuiltinInterface {
}
class SymbolValue extends BuiltinValueObject {
    constructor() {
        super(...arguments);
        this.type = 'SymbolConstructor';
    }
}
class SymbolConstructorInterface extends BuiltinInterface {
}
export const add = (builtins) => {
    builtins.addInterface('Symbol', new SymbolInterface());
    builtins.addValue('Symbol', new SymbolValue());
    builtins.addInterface('SymbolConstructor', new SymbolConstructorInterface());
    builtins.addGlobalMember('SymbolConstructor', 'for', new SymbolFor());
    builtins.addGlobalMember('SymbolConstructor', 'iterator', new SymbolIterator());
    builtins.addGlobalMember('SymbolConstructor', 'toPrimitive', new SymbolToPrimitive());
};

//# sourceMappingURL=index.js.map
